<div class="container">
    <h4>
        Test clock
    </h4>
    <hr/>

    <ng-container *ngIf="clock && !clock.isProduction">
        <p class="text-muted">
            Simulated "today" used by review-date gating in this non-production environment.
            While set, it appears in the status banner and drives all date-window calculations.
        </p>
        <div class="form-inline">
            <input type="date" class="form-control"
                [(ngModel)]="simulatedDateInput"
                [ngModelOptions]="{standalone: true}" />
            <button class="btn btn-primary ml-2"
                (click)="setClock()"
                [disabled]="!simulatedDateInput">
                Set
            </button>
            <button class="btn btn-outline-secondary ml-2"
                (click)="clearClock()"
                [disabled]="!clock.simulatedDate">
                Clear
            </button>
        </div>
    </ng-container>

    <p *ngIf="clock && clock.isProduction" class="text-muted">
        The test clock is disabled in production. Date gating always runs on the real date here.
    </p>
</div>
